import { Controller } from "@hotwired/stimulus";
import { computePosition, flip, shift, offset } from "@floating-ui/dom";

export default class extends Controller {
  static targets = ["box", "overlay"];

  declare boxTarget: HTMLElement;
  declare overlayTarget: HTMLElement;
  private isVisible = false;

  async toggle() {
    this.isVisible = !this.isVisible;

    if (this.isVisible) {
      this.boxTarget.classList.remove("hidden");
      this.overlayTarget.classList.remove("hidden");
      await this.updatePosition();
    } else {
      this.boxTarget.classList.add("hidden");
      this.overlayTarget.classList.add("hidden");
    }
  }

  async updatePosition() {
    if (!this.isVisible) return;

    const { x, y } = await computePosition(this.element, this.boxTarget, {
      placement: "bottom-start",
      middleware: [offset(4), flip(), shift({ padding: 8 })],
    });

    Object.assign(this.boxTarget.style, {
      position: "absolute",
      left: `${x}px`,
      top: `${y}px`,
    });
  }
}
